module.exports = __webpack_public_path__ + "static/media/boat.9ec19722.gif";